<template>
    <div>
        <p class="label">{{ label }}</p>
         <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" :loading="isLoading" />
       <!--  <v-autocomplete
                hide-details
                v-model="pickedIds"
                :items="items"
                item-value="id"
                item-text="name"
                multiple
                outlined
                hide-no-data
                :loading="isLoading"
                @change="onChange"
                v-bind="$attrs"
        >
            <template v-slot:selection="{ item, index }">
                <span
                        v-if="index === 0"
                        class="grey--text caption"
                >
                    <template v-if="pickedIds.length === 1">{{ pickedIds.length }} item</template>
                    <template v-else>{{ pickedIds.length }} items</template>
                </span>
            </template>
        </v-autocomplete>
        <v-flex xs12 sm12 md12 v-if="pickedItems.length > 0">
            <v-flex xs12>
                <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
                    <template v-for="(item, index) in pickedItems">
                        <v-chip
                                close-icon="$close"
                                close
                                outlined
                                label
                                color="#202020"
                                :key="item.id"
                                class="mr-2 my-1"
                                @click:close="unpick(index)"
                        >
                            <span class="body-2">{{ item.name }}</span>
                        </v-chip>
                    </template>
                </v-card>
            </v-flex>
        </v-flex> -->
    </div>
</template>

<script>
  import DepartmentService from '@/services/department.service.js';
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';

  export default {
    name: "DepartmentMultiplePickerInput",
    props: {
      value: { type: Array, default: () => []},
      label: {type: String, default: 'Département(s)'},
      regionIds: { type: Array, default: () => []},
      taskEdit: { type: Boolean, default: false }
    },
    components: {
      MultiplePickerInput
    },
    data() {
      return {
        items: [],
        isLoading: false,
        search: null,
        pickedIds: [],
        timeoutHandler: null,
      }
    },
    computed: {
      pickedItems() {
        const _this = this;

        return _this.pickedIds.map((id) => {
          return _this.items.find((item) => {
            return item.id === id;
          })
        });
      },
    },
    methods: {
      loadListItem() {
        const _this = this;

        // if (this.items.length > 0 || !this.regionIds.length) return;

        if (this.isLoading) return;

        this.isLoading = true;

        DepartmentService.getListByStudent(this.regionIds)
          .then(({data}) => {
            _this.items = data.map(item => {
              item.name = item.departmentCode ? `${item.departmentCode} - ${item.name}` : `${item.name}`;
              return item;
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      unpick(index) {
        this.pickedIds.splice(index, 1);

        this.$emit('input', this.pickedIds);
      },
      onChange(value) {
        this.$emit('input', value);
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      regionIds: {
        immediate: true,
        handler(value) {
          const _this = this;
          this.items = [];
          this.pickedIds = [];

          //check task edit 
          if(!this.taskEdit){
            this.$emit('input', []);
          }else{
            this.$emit('resetTask', false);
          }

          if (Array.isArray(value) && value.length > 0) {
            clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              _this.loadListItem();
            }, 1000);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
